module.exports = __webpack_public_path__ + "static/media/Amarjeet Sonkar.e39f5ccd.png";